import React from 'react';
import PropTypes from 'prop-types';
import {Card, CardHeader, CardText} from 'material-ui/Card';
import ServiceListItem from './ServiceListItem';

export default class ServiceCategory extends React.Component {

  static propTypes = {
    service: PropTypes.object.isRequired,
    checkedServices: PropTypes.object,
    onCheckService: PropTypes.func,
  };

  static defaultProps = {
    checkedServices: {},
    onCheckService: () => {},
  };

  state = {
    expanded: false,
  };

  shouldComponentUpdate(nextProps, nextState) {
    // Only update if new "checked" or expanded update
    // /!\ For performance reason, we DO NOT check for services updates
    // If you need to update services in a category AFTER load,
    // please update this condition
    if (this.props.checkedServices !== nextProps.checkedServices
      || this.state.expanded !== nextState.expanded)
    {
      return true;
    } else {
      return false;
    }
  }

  handleExpandChange = (expanded) => {
    this.setState({ expanded: expanded });
  };

  handleCheckService = (subServiceId, serviceId, event) => {
    this.props.onCheckService(subServiceId, serviceId, event, !this.props.checkedServices[subServiceId]);
  }

  isServiceChecked(service) {

    if (!this.props.checkedServices[service]) {
      return false;
    }

    return this.props.checkedServices[service];
  }

  renderService() {
    const service = this.props.service;
    let content;
    let servicesContent = [];

    // Only display categories with a least one service
    //if (0 === Object.keys(service.services).length) {
    //  return;
    //}

    Object.keys(service.services).forEach(subServiceKey => {
      const subService = service.services[subServiceKey];

      const checkedValues = Object.values(this.props.checkedServices).filter(key => service.id);
      let checked = 0;
      checkedValues.forEach(function(value) {
        if (value)
          checked++;
      });
      const disabled = checked >= 1;

      servicesContent.push(
        <ServiceListItem
          key={service.name + '-' + subService.name}
          name={subService.name}
          price={subService.price}
          time={subService.time}
          coiffure={this.props.coiffure}
          showPrices={this.props.showPrices}
          checked={this.isServiceChecked(subServiceKey)}
          onChecked={this.handleCheckService.bind(null, subService.id, service.id)}
          disabled={!this.isServiceChecked(subServiceKey) && disabled && this.props.coiffure}
        />
      );
    });

    content = (
      <Card
        zDepth={1}
        expanded={this.state.expanded}
        onExpandChange={this.handleExpandChange}
        style={{
          margin: 0,
        }}
      >
        <CardHeader
          title={this.props.service.name}
          subtitle={Object.keys(service.services).length + ' services'}
          avatar={service.icon}
          actAsExpander={true}
          showExpandableButton={true}
        />
        <CardText expandable={true}>
          {servicesContent}
        </CardText>
      </Card>
    );

    return content;
  }


  render() {
    return (
      <div style={{ margin: '7px 2px 7px 2px' }}>
        {this.renderService()}
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/ServiceCategory.js